import './App.css'
import ProductosState from './context/productos/productosState'
import { HomeProvider } from './contexts/HomeContext'
import Navigator from './navigator/Navigator'

function App() {
  return (
      <ProductosState>
        <HomeProvider>
          <Navigator />
        </HomeProvider>
      </ProductosState>
  )
}

export default App
